module.exports = __webpack_public_path__ + "img/chamada-ebook.900dd4df.png";